import { AbstractControl, ValidationErrors } from '@angular/forms';

export class TcValidators {
  static pattern(regex: RegExp, error: ValidationErrors) {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) {
        // if control is empty return no error
        return null;
      }

      // test the value of the control against the regexp supplied
      const valid = regex.test(control.value);

      // if true, return no error (no error), else return error passed in the second parameter
      return valid ? null : error;
    };
  }

  static email = TcValidators.pattern(/([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})/, {
    email: true,
  });

  /** Handle mobile phone with format such as +33 6 12 34 56 78, 06 12 34 56 78 and same with spaces or dots */
  static mobilePhone = TcValidators.pattern(/^(?:(?:\+|00)33|0)\s*[1-9](?:[\s.-]*\d{2}){4}$/, {
    mobilePhone: true,
  });

  static solde = TcValidators.pattern(/^-?[0-9]+([,.][0-9]{1,2})?$/, {
    solde: true,
  });
}
